import * as React from 'react';
import styles from './index.less';
import { Modal, Pagination } from 'antd';
import FComponentsLib from '@freelog/components-lib';
import FSelect2 from '@/components/FSelect2';
import FDropdown from '@/components/FDropdown';
import { FI18n, FUtil } from '@freelog/tools-lib';
// import {
//   ChangeAction,
//   Version_Fetch_CollectionItems_Action,
// } from '@/models/collectionManager';
// import fMessage from '@/components/fMessage';
import FCollectionItems2 from '@/components/FCollectionItems2';
import * as AHooks from 'ahooks';

interface SortOrderModalProps {
  open: boolean;
  // setting 配置 https://freelog.yuque.com/org-wiki-freelog-qqxqll/gkva0w/rupov7xgdy5rxr50?inner=Q09Zp
  setting: {
    collection_sort_list:
      | 'collection_sort_ascending'
      | 'collection_sort_descending';
    collection_item_title:
      | 'collection_item_title_rtitle'
      | 'collection_item_title_sn'
      | 'collection_item_title_empty'
      | 'collection_item_title_custom';
    collection_item_no_display:
      | 'collection_item_no_display_show'
      | 'collection_item_no_display_hide';
    collection_item_image_display:
      | 'collection_item_image_display_show'
      | 'collection_item_image_display_hide';
    collection_item_descr_display:
      | 'collection_item_descr_display_show'
      | 'collection_item_descr_display_hide';
    collection_view: 'collection_view_list' | 'collection_view_card';
  };

  pageCurrent: number;
  pageSize: number;
  totalCount: number;

  collectionItems: {
    itemID: string;
    itemTitle: string;
    itemSerial: number;
    itemNumber: string;
    resourceInfo: {
      id: string;
      cover: string;
      name: string;
      title: string;
      version: string;
      policy: string[];
      type: string[];
      status: 0 | 1 | 2 | 4;
      authProblem: boolean;
      updateDate: string;
      username: string;
      useAvatar: string;
      isChoice: boolean;
      intro: string;
    };
  }[];

  // onConfirmIndex?(index: number | 'front' | 'back'): void;
  onChangeItemsSortID?(itemIDs: string[], index: number): void;

  onChangeSortSetting?(
    sort: 'collection_sort_ascending' | 'collection_sort_descending',
  ): void;

  onClickSortBy?(sort: 'added' | 'title' | 'updateDate'): void;

  onChangeSetting?(setting: SortOrderModalProps['setting']): void;

  onChangePage?(page: number, pageSize: number): void;

  onCancel?(): void;
}

function SortOrderModal({
  open,
  setting,
  pageCurrent,
  pageSize,
  totalCount,
  collectionItems,
  onChangeItemsSortID,
  onChangeSortSetting,
  onChangeSetting,
  onClickSortBy,
  onChangePage,
  onCancel,
}: SortOrderModalProps) {
  const refContent = React.useRef<any>();

  const [$checkedItemIDs, set$checkedItemIDs, get$checkedItemIDs] =
    FUtil.Hook.useGetState<string[]>([]);
  const [$numInput, set$numInput, get$numInput] =
    FUtil.Hook.useGetState<string>('');

  AHooks.useDebounceEffect(
    () => {
      const itemIDs: string[] = get$checkedItemIDs().filter((id) => {
        return collectionItems.some((ci) => {
          return ci.itemID === id;
        });
      });
      // console.log(itemIDs, 'itemIDsisdjflksdjl;kfjlkjl');
      set$checkedItemIDs(itemIDs);
    },
    [collectionItems],
    {
      wait: 300,
    },
  );

  return (
    <Modal
      open={open}
      title={null}
      footer={null}
      width={940}
      centered={true}
      style={{ borderRadius: 10, overflow: 'hidden' }}
      bodyStyle={{
        // height: 'calc(100vh - 200px)',
        padding: 0,
      }}
      onCancel={onCancel}
      afterClose={() => {
        set$checkedItemIDs([]);
      }}
    >
      <div ref={refContent} style={{ padding: '0 30px' }}>
        <div style={{ height: 30 }} />
        <FComponentsLib.FTitleText
          type={'popup'}
          text={'调整排序'}
          style={{ textAlign: 'center' }}
        />
        <div style={{ height: 10 }} />
        <FComponentsLib.FContentText
          type={'additional2'}
          text={
            '排序功能将为单品确定序号，您的设置的序号将在合集详情页生效，也对合集在终端的展示产生影响。'
          }
          style={{ textAlign: 'center' }}
        />
        <div style={{ height: 30 }} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          {$checkedItemIDs.length === 0 && (
            <div style={{ flexBasis: 170 }}>
              {/*<FComponentsLib.FContentText*/}
              {/*  type={'additional2'}*/}
              {/*  text={'排序方式'}*/}
              {/*  style={{ fontWeight: 600, color: '#222' }}*/}
              {/*/>*/}
              {/*<div style={{ height: 5 }} />*/}
              <FSelect2
                value={
                  setting?.collection_sort_list || 'collection_sort_ascending'
                }
                options={[
                  {
                    value: 'collection_sort_ascending',
                    label: '升序',
                  },
                  {
                    value: 'collection_sort_descending',
                    label: '降序',
                  },
                ]}
                style={{ width: '100%' }}
                onChange={(value) => {
                  onChangeSetting?.({
                    ...setting,
                    collection_sort_list: value,
                  });
                  onChangeSortSetting?.(value);
                }}
              />
            </div>
          )}

          {$checkedItemIDs.length > 0 && (
            <div style={{ flexBasis: 380 }}>
              {/*<FComponentsLib.FContentText*/}
              {/*  type={'additional2'}*/}
              {/*  text={'排序功能'}*/}
              {/*  style={{ fontWeight: 600, color: '#222' }}*/}
              {/*/>*/}
              {/*<div style={{ height: 5 }} />*/}
              <div
                style={{
                  height: 38,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 30,
                }}
              >
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  style={{ fontSize: 12, lineHeight: '18px' }}
                  onClick={() => {
                    // onConfirmIndex?.('front');
                    onChangeItemsSortID?.(get$checkedItemIDs(), 1);
                    set$checkedItemIDs([]);
                  }}
                >
                  移至最前
                </FComponentsLib.FTextBtn>
                <FComponentsLib.FTextBtn
                  type={'primary'}
                  style={{ fontSize: 12, lineHeight: '18px' }}
                  onClick={() => {
                    // onConfirmIndex?.('back');
                    onChangeItemsSortID?.(get$checkedItemIDs(), totalCount);
                    set$checkedItemIDs([]);
                  }}
                >
                  移至最后
                </FComponentsLib.FTextBtn>

                <div
                  style={{
                    height: 32,
                    flexBasis: 185,
                    flexShrink: 0,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                  }}
                >
                  <FComponentsLib.FContentText
                    type={'additional2'}
                    // text={'移动至'}
                    text={FI18n.i18nNext.t('cqr_itemmgmt_entry_moveto')}
                    style={{ color: '#222' }}
                  />
                  <FComponentsLib.FInput.FSingleLine
                    lengthLimit={-1}
                    // value={$order}
                    value={$numInput}
                    style={{ width: 60 }}
                    size={'small'}
                    onChange={(e) => {
                      const num: string = e.target.value;
                      if (num !== '' && !new RegExp(/^[1-9]\d*$/).test(num)) {
                        return;
                      }
                      set$numInput(num);
                    }}
                  />
                  <FComponentsLib.FTextBtn
                    style={{ fontSize: 12 }}
                    disabled={$numInput === ''}
                    onClick={() => {
                      // onConfirmIndex?.(Number(get$numInput()));
                      onChangeItemsSortID?.(
                        get$checkedItemIDs(),
                        Math.max(
                          Math.min(Number(get$numInput()), totalCount),
                          1,
                        ),
                      );
                      set$numInput('');
                      set$checkedItemIDs([]);
                    }}
                  >
                    {FI18n.i18nNext.t('cqr_itemmgmt_entry_moveto_btn')}
                  </FComponentsLib.FTextBtn>
                </div>
              </div>
            </div>
          )}

          <FDropdown
            getPopupContainer={() => {
              return refContent.current;
            }}
            // open={true}
            // overlayClassName={styles.overlayClassName}
            menu={{
              items: [
                {
                  key: 'added',
                  label: '最近添加在前',
                  onClick({ key }) {
                    onClickSortBy?.('added');
                  },
                },
                {
                  key: 'title',
                  label: '单品标题 （A-Z）',
                  onClick({ key }) {
                    onClickSortBy?.('title');
                  },
                },
                {
                  key: 'updateDate',
                  label: '最近更新在前',
                  onClick({ key }) {
                    onClickSortBy?.('updateDate');
                  },
                },
              ],
            }}
            placement="bottomRight"
          >
            <div>
              <FComponentsLib.FTextBtn
                type={'primary'}
                style={{ fontSize: 12, lineHeight: '18px' }}
                onClick={() => {
                  // onClose?.();
                }}
              >
                快速排序
              </FComponentsLib.FTextBtn>
            </div>
          </FDropdown>
        </div>
        <div style={{ height: 20 }} />
        <div
          style={{
            maxHeight: 'calc(100vh - 235px - 40px)',
            minHeight: 'calc(500px - 235px + 65px)',
            margin: '0 -30px',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <div style={{ margin: '0 auto', width: 880 }}>
            <FCollectionItems2
              draggable={true}
              showView={
                setting.collection_view === 'collection_view_list'
                  ? 'list'
                  : 'card'
              }
              showCheckbox={'show'}
              checkedItemIDs={$checkedItemIDs}
              showCover={'show'}
              showNumber={'show'}
              showTitle={'title'}
              showIntroduction={'hide'}
              resources={collectionItems}
              // onClick={(itemID, resourceID) => {
              //   set$handlingCollectionItem(itemID);
              //   set$authProcessorShow(get$authProcessorShow() + 1);
              //   set$licensorId(resourceID);
              // }}
              onChangeChecked={async (itemID, checked) => {
                if (checked) {
                  set$checkedItemIDs([...get$checkedItemIDs(), itemID]);
                } else {
                  set$checkedItemIDs(
                    get$checkedItemIDs().filter((i) => {
                      return i !== itemID;
                    }),
                  );
                }
              }}
              // onChangeCustomTitle={async (itemID, title) => {
              //   // await FServiceAPI.Resource.setItemsTitle({
              //   await FServiceAPI.Resource.updateCollectionItemsInfo_Draft({
              //     resourceId: collectionManager.version_resourceID,
              //     data: [{
              //       itemId: itemID,
              //       itemTitle: title,
              //     }],
              //   });
              //   await onChange_needSaveDraft_collectionItems({});
              //   await dispatch<ChangeAction>({
              //     type: 'collectionManager/change',
              //     payload: {
              //       version_collectionItems: collectionManager.version_collectionItems.map((vc) => {
              //         if (vc.itemID !== itemID) {
              //           return vc;
              //         }
              //         return {
              //           ...vc,
              //           itemTitle: title,
              //         };
              //       }),
              //     },
              //   });
              // }}
              // onClickDelete={async (itemID) => {
              //   const { data } = await FServiceAPI.Resource.deleteCollectionItems_Draft({
              //     resourceId: collectionManager.version_resourceID,
              //     removeCollectionItemIds: [itemID],
              //   });
              //   await dispatch<ChangeAction>({
              //     type: 'collectionManager/change',
              //     payload: {
              //       version_resources_pageCurrent: Math.min(
              //         Math.floor((collectionManager.version_resources_totalCount - 1) / collectionManager.version_resources_pageSize) + 1,
              //         collectionManager.version_resources_pageCurrent,
              //       ),
              //     },
              //   });
              //   await dispatch<Version_Fetch_CollectionItems_Action>({
              //     type: 'collectionManager/version_Fetch_CollectionItems',
              //   });
              //   // await dispatch<Version_FetchDataSourceAction>({
              //   //   type: 'collectionManager/version_fetchDataSource',
              //   // });
              //   await onChange_needSaveDraft_collectionItems({});
              //
              //   if (collectionManager.version_resourceInfo) {
              //     const { data: data_collectionItems }: {
              //       ret: number;
              //       errCode: number;
              //       data: {
              //         skip: number;
              //         limit: number;
              //         totalItem: number;
              //         dataList: [];
              //       }
              //     } = await FServiceAPI.Resource.getCollectionItems_Draft({
              //       resourceId: collectionManager.version_resourceID,
              //       limit: 1,
              //     });
              //
              //     dispatch<ChangeAction>({
              //       type: 'collectionManager/change',
              //       payload: {
              //         version_resourceInfo: {
              //           ...collectionManager.version_resourceInfo,
              //           itemsTotalCount: data_collectionItems.totalItem,
              //         },
              //       },
              //     });
              //   }
              // }}
              onChangeIndex={async (id, index, newList) => {
                const sortID: number =
                  setting?.collection_sort_list === 'collection_sort_ascending'
                    ? (pageCurrent - 1) * pageSize + index + 1
                    : totalCount - (pageCurrent - 1) * pageSize - index;

                onChangeItemsSortID?.([id], sortID);
              }}
            />
          </div>
        </div>

        {((setting.collection_view === 'collection_view_list' &&
          totalCount > 10) ||
          (setting.collection_view === 'collection_view_card' &&
            totalCount > 6)) && (
          <>
            <div style={{ height: 20 }} />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Pagination
                showTitle={false}
                locale={{
                  // items_per_page: '条/页',
                  items_per_page: FI18n.i18nNext.t(
                    'cqr_itemmgmt_list_pagenation_perpage',
                  ),
                  // jump_to: '前往',
                  jump_to: FI18n.i18nNext.t(
                    'cqr_itemmgmt_list_pagenation_currentpage',
                  ),
                  // page: '页',
                  page: ' ',
                }}
                size="small"
                showSizeChanger
                showQuickJumper
                current={pageCurrent}
                pageSize={pageSize}
                total={totalCount}
                onChange={onChangePage}
                showTotal={(total) => {
                  // return `共${total}条`;
                  return FI18n.i18nNext.t(
                    'cqr_itemmgmt_list_pagenation_total',
                    {
                      PageCount: total,
                    },
                  );
                }}
                pageSizeOptions={
                  setting.collection_view === 'collection_view_card'
                    ? [6, 12, 18, 24, 30]
                    : [10, 20, 30, 40, 50]
                }
              />
            </div>
          </>
        )}
        <div style={{ height: 20 }} />
      </div>
    </Modal>
  );
}

export default SortOrderModal;
